import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export interface PatchRoomRateInterconnectingParams {
  propertyId: string;
  roomTypeId: string;
  roomRateId: string;
  isInterconnecting: boolean;
}

export function usePatchRoomRateInterconnecting() {
  return useMutation({
    mutationFn: ({ propertyId, roomTypeId, roomRateId, isInterconnecting }: PatchRoomRateInterconnectingParams) =>
      ReservationService.patchRoomRateInterconnecting(propertyId, roomTypeId, roomRateId, isInterconnecting),
  });
}
